export default "__VITE_ASSET__DEZTgZxK__"